import { AllActions, AllActionsEnum } from "../../reducers/actions";
import { citizenApi } from "../../services/citizen-api-instance";

export async function retrieveQuestionnaire(setRootStore: (action: AllActions) => void) {
  try {
    const {
      data: { questionnaire },
    } = await citizenApi.getQuestionnaireFields();

    setRootStore({ type: AllActionsEnum.UPDATE_QUESTIONNAIRE, payload: { questionnaire, notify: true } });
  } catch (error: unknown) {
    console.error("FAILED TO LOAD CITIZEN QUESTIONNAIRE", error);
  }
}
